import React from 'react'
import Section from '../Section'
import Markdown from 'features/Markdown'

export default props => (
  <Section color={props.color} paddingTop={'40px'} paddingBottom={'40px'}>
    <Markdown text={props.text} color={props.color} />
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/HeadingDivider/HeadingDivider.jsx